import React from 'react';
import PropTypes from 'prop-types';
import './QueueList.scss';
import ThreeDot from '../icons/ThreeDotIcon';
import GetNextIcon from '../icons/GetNextIcon';
import PopupMenu from 'Components/popup-menu/PopupMenu';
import Badge from '../Badge/Badge';
import QueueDisableIcon from '../icons/QueueDisableIcon';
import QueueEnableIcon from '../icons/QueueEnableIcon';
import SubQueueSeparator from '../icons/SubQueueSeparator';

const QueueList = (props) => {
  const onClickThreeDot = (action) => {
    props.onViewClick({ action: action, queue: props.selecedQueue })
  }

  return (
    <div className="QueueList">
      <div className={props.subQueue != undefined && props.subQueue ? "QueueList-narrow" : "QueueList-wide"}>
        <div
          className={props.isBorder ? "listview view-last-border" : "listview"}
          key={props.id}
        >
          <div role="button" className="link-wrapper">
            <div className="left-side-listview">
              <span
                className={props.cursorView ? "cursor-view" : "default-cursor"}
                onKeyDown={() => props?.onViewClick(props.id)}
                onClick={() => props?.onViewClick(props.id)}
              >
                <div className={props.title ? (props.subQueue ? "title-subQueue" : "title-view") : ""}>
                  <div className={(props.subQueue && !props.title) ? "box" : ""}>{props.name}</div>
                </div>
              </span>
            </div>
            {props.isLanding && props.user !== undefined && props.user.parsedPermissions.queue.getNextCaseInQueue &&
              <span className="getNextIcon" onClick={() => props.goToSubQueueLanding()}><GetNextIcon /></span>
            }
            {props.parentComponentName == "CreatCustomQueLanding" &&
              <span className="adminBadgeSpan">
                <Badge spanClass={'subQueueBadge'} badgeType={'info'}>
                  {props.visibilityInd ? <QueueEnableIcon /> : <QueueDisableIcon />}
                </Badge>

                <div className="subQueueSeparator"> <SubQueueSeparator /> </div>

                <div className='threedot' style={{ marginRight: '85px' }}>
                  <PopupMenu
                    isCreateQueue={true}
                    position={"top"}
                    popupContent={props.popupContent}
                    trailingText={props.trailingText}
                    editText={""}
                    goToLink={onClickThreeDot}
                    parentComponentName={props.parentComponentName}
                    poupUpBottom={props.poupUpBottom}
                  >
                    <ThreeDot />
                  </PopupMenu>
                </div>
              </span>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

QueueList.propTypes = {
  extraClass: PropTypes.string,
  name: PropTypes.string,
  count: PropTypes.number,
  isBorder: PropTypes.bool,
  parentComponentName: PropTypes.string,
  isLanding: PropTypes.bool,
  selecedQueue: PropTypes.object,
  visibilityInd: PropTypes.bool,
  user: PropTypes.object,
  poupUpBottom: PropTypes.string,
  cursorView: PropTypes.bool
};

QueueList.defaultProps = {
  extraClass: '',
  isBorder: false,
  parentComponentName: "",
  isLanding: false,
  selecedQueue: {},
  cursorView: true,
};

export default QueueList;
